/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AlarmOverviewLinks } from './alarmOverviewLinks';


export interface AlarmOverview { 
    alarm?: string;
    count?: number;
    duration?: number;
    alarm_id?: string;
    _links?: AlarmOverviewLinks;
}

